import React from "react";

const CTA = ({ heading, subheading, paragraph, buttonText }) => {
    return (
        <div className="bg-blue-600 text-white py-12 md:py-20 px-6 md:px-12 lg:px-24"> {/* Adjusted py for mobile */}
            <div className="max-w-7xl mx-auto text-center"> {/* Center text on mobile */}
                <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-[48px] leading-tight font-bold mb-6 md:mb-4"> {/* Adjusted text size and margin for mobile */}
                    {heading} {subheading && (<span className="italic font-light lg:text-[42px] xl:text-[42px] text-xl md:text-2xl">{/* Adjusted italic text size */} - {subheading}</span>)}
                </h1>
                <p className="text-base md:text-lg leading-relaxed mb-8">{paragraph}</p> {/* Adjusted text size for mobile */}
                <div className="flex justify-center"> {/* Center button on mobile */}
                    <a href="https://forms.gle/zSmP9UA2vg3Nfq7v9" target="_blank" rel="noopener noreferrer">
                        <button className="bg-white text-blue-600 font-semibold text-md py-3 px-8 rounded-full shadow-md hover:bg-blue-100 transition-colors duration-300">
                            {buttonText}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CTA;